module.exports = __webpack_public_path__ + "static/media/waitApprove.4a2f5fc8.svg";